import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import isAuthenticated from "../../components/Utils/isAuthenticated";
import PropTypes from "prop-types";
import { Box, Tabs, Tab } from "@mui/material";
import { useTermsQueryFull } from "../../Hooks/useTermsQuery";
import EmailSPOTResults from "./tabs/EmailSPOTResults";
import CSVUploads from "./tabs/CSVUploads";
import LDAPSearch from "./tabs/LDAPSearch";
import PopulateQP from "./tabs/PopulateQP";
import MidtermEmail from "./tabs/MidtermEmail";
import DataVerification from "./tabs/DataVerification";

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

export default function AdminUtils() {
	const [searchParams, setSearchParams] = useSearchParams();
	const tabParam = parseInt(searchParams.get("tab"), 10);
	const [value, setValue] = React.useState(
		Number.isInteger(tabParam) && tabParam >= 0 && tabParam <= 5 ? tabParam : 0,
	);

	const auth = isAuthenticated();
	const token = auth.token;

	const [instructorsForEmail, setInstructorsForEmail] = useState([]);

	const [resultsMessage, setResultsMessage] = useState("");

	const [allDepartmentsResults, setAllDepartmentsResults] = useState([]);
	const [termValue, setTermValue] = useState("");
	const [termNumber, setTermNumber] = useState(null);
	const [terms, setTerms] = useState([]);
	const { data: termsList } = useTermsQueryFull(token);
	const [loadingCheckDepartments, setLoadingCheckDepartments] = useState(false);

	useEffect(() => {
		if (termsList && termsList.length > 0) {
			const termDescriptions = termsList.map((term) => term.desc);
			const termNumbers = termsList.map((term) => term.term);
			const terms = termNumbers.map((term, index) => {
				return termDescriptions[index] + " (" + term + ")";
			});
			setTerms(terms);

			const highestTermNumber = Math.max(...termNumbers);
			const highestTermIndex = termNumbers.indexOf(highestTermNumber);
			const highestTerm = terms[highestTermIndex];
			setTermValue(highestTerm);
		}
	}, [termsList]);

	useEffect(() => {
		if (termsList && termsList.length > 0 && termValue && termValue.length > 0) {
			//get value in brackets of termValue
			const termNumber = termValue.match(/\(([^)]+)\)/)[1];
			setTermNumber(Number(termNumber));
		}
	}, [termsList, termValue]);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		setSearchParams({ tab: newValue });
	};

	const handleChangeTerm = (event) => {
		const termNumber = event.target.value.match(/\(([^)]+)\)/)[1];
		if (Number(termNumber) >= 1890) {
			setTermValue(event.target.value);
			setResultsMessage("");
			setInstructorsForEmail([]);
		} else {
			alert("Terms earlier than 1890 are not supported.");
		}
	};

	return (
		<div className="w-full">
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
					<Tab label="Email Instructor Results" {...a11yProps(0)} />
					<Tab label="CSV Uploads" {...a11yProps(1)} />
					<Tab label="LDAP Search" {...a11yProps(2)} />
					<Tab label="Populate QP" {...a11yProps(3)} />
					<Tab label="Midterm Email" {...a11yProps(4)} />
					<Tab label="Data Verification" {...a11yProps(5)} />
				</Tabs>
			</Box>
			<EmailSPOTResults
				value={value}
				terms={terms}
				termValue={termValue}
				handleChangeTerm={handleChangeTerm}
				termNumber={termNumber}
				allDepartmentsResults={allDepartmentsResults}
				loadingCheckDepartments={loadingCheckDepartments}
				instructorsForEmail={instructorsForEmail}
				resultsMessage={resultsMessage}
				setResultsMessage={setResultsMessage}
				token={token}
				setInstructorsForEmail={setInstructorsForEmail}
				setLoadingCheckDepartments={setLoadingCheckDepartments}
				setAllDepartmentsResults={setAllDepartmentsResults}
			/>
			<CSVUploads value={value} token={token} />
			<LDAPSearch value={value} token={token} />
			<PopulateQP
				value={value}
				token={token}
				terms={terms}
				termValue={termValue}
				termNumber={termNumber}
				handleChangeTerm={handleChangeTerm}
			/>
			<MidtermEmail
				value={value}
				token={token}
				terms={terms}
				termValue={termValue}
				termNumber={termNumber}
				handleChangeTerm={handleChangeTerm}
			/>
			<DataVerification value={value} token={token} />{" "}
		</div>
	);
}
